import { Dispatch, SetStateAction } from "react";

type DesignPreviewDialogArg = {
	setShowPalette: Dispatch<SetStateAction<boolean>>;
};

// ダイアログの共通のロジックを提供します
export default function useDesignPreviewtDialog(arg: DesignPreviewDialogArg) {
	const { setShowPalette } = arg;

	// 保存もしくはリセットボタンクリック時の共通処理
	// TODO: これここに書いているが、他のアイコンクリック時の処理でも必要なので
	// ふと思ったが、表示非表示を管理する、辞書のようなものを作れば良いのか？
	// また、名前が終わっているんだよなあ
	// 親コンポーネントの方で（Designで）closeAllIconsというような関数を作るのが良いか
	const onApplyClick = () => {
		// パレットや移動アイコンなど開いているものを全て閉じる
		setShowPalette((prev) => false);
	};

	return { onApplyClick };
}
